import { lazy } from 'react';
import { Route, Outlet } from 'react-router-dom';

// const NfmsDashboard = lazy(() => import('@/pages/nfms/dashboard'));
const FeederMasterData = lazy(() => import('@/pages/nfms/feeder-master-data'));
const BlockLoadSync = lazy(()  => import('@/pages/nfms/block-load-sync'));
const NFMSSuccessLogs = lazy(
  () => import('@/pages/nfms/nfms-logs/success-logs')
);
const NFMSFailedLogs = lazy(() => import('@/pages/nfms/nfms-logs/failed-logs'));
const RealtimeAlarmsSync = lazy(
  () => import('@/pages/nfms/real-time-alarms-sync')
);

const NfmsRoutes = (
  <Route path="nfms" element={<Outlet />}>
    <Route index element={<FeederMasterData />} />
    <Route path="feeder-master-data" element={<FeederMasterData />} />
    <Route path="block-load-sync" element={<BlockLoadSync />} />
    <Route path="logs/success-logs" element={<NFMSSuccessLogs />} />
    <Route path="logs/failed-logs" element={<NFMSFailedLogs />} />
    <Route path="realtime-alarms-sync" element={<RealtimeAlarmsSync />} />
  </Route>
);

export default NfmsRoutes;
